import React, { MouseEvent, useEffect, useState } from "react";
import { HalfSplitRow } from "@components/templates/layouts/half-split-row/half-split-row";
import { LabelPlusInputAndDropDown } from "@components/molecules/label-plus-input-and-drop-down/label-plus-input-and-dropdown";
import { LabelPlusRoundButtonTabs } from "@components/molecules/label-plus-round-button-tabs/label-plus-round-button-tabs";
import styles from "./data-acquisition-type-items-wrapper.module.scss";
import { DataAcquisitionTypeMonitoringInfoIconAndTextWrapper } from "@components/molecules/data-acquisition-type-monitoring-info-icon-and-text-wrapper/data-acquisition-type-monitoring-info-icon-and-text-wrapper";
import { useI18N } from "@src/language/language-context";

const cssClassName = "data-acquisition-type-items-wrapper";

export interface RoundButtonTypes {
  name: string;
  value: string;
  selected: boolean;
}

interface DataAcquisitionTypeItemsWrapperPropTypes {
  dataAcquisitionType: string;
  intervalInSeconds: number;
  updateFunc: (array: RoundButtonTypes[]) => void;
  returnSecondsFromInputAndDropDown: (timeIntervalInSeconds: number) => void;
}

export const DataAcquisitionTypeItemsWrapper = ({
  dataAcquisitionType,
  intervalInSeconds,
  updateFunc,
  returnSecondsFromInputAndDropDown,
}: DataAcquisitionTypeItemsWrapperPropTypes) => {
  const i18n = useI18N();
  const [roundButtonTypesArray, setRoundButtonTypesArray] =
    useState<RoundButtonTypes[]>();

  const arrayOfRoundButtons = [
    {
      name: "Polling",
      value: "POLLING",
      selected: true,
    },
    {
      name: "Monitoring",
      value: "MONITORING",
      selected: false,
    },
  ];

  const buildUpdatedArray = (selectedButtonValue) => {
    const updatedArray = arrayOfRoundButtons.map((button) => ({
      ...button,
      selected: button.value === selectedButtonValue,
    }));

    return updatedArray;
  };

  const onClickHandler = (e: MouseEvent, value: string) => {
    e.preventDefault();

    const updatedArray = buildUpdatedArray(value);

    setRoundButtonTypesArray(updatedArray);
    updateFunc(updatedArray);
  };

  useEffect(() => {
    setRoundButtonTypesArray(buildUpdatedArray(dataAcquisitionType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAcquisitionType]);

  return (
    <div className={styles[cssClassName]}>
      <HalfSplitRow>
        <LabelPlusRoundButtonTabs
          labelText={i18n("modules.ourNodeDetailsPanel.databit")}
          roundButtonTypesArray={roundButtonTypesArray}
          onClickHandler={onClickHandler}
        />
        {dataAcquisitionType === "POLLING" ? (
          <LabelPlusInputAndDropDown
            labelText={i18n("modules.ourNodeDetailsPanel.pollDataEvery")}
            intervalInSeconds={intervalInSeconds}
            callback={returnSecondsFromInputAndDropDown}
          />
        ) : (
          <DataAcquisitionTypeMonitoringInfoIconAndTextWrapper />
        )}
      </HalfSplitRow>
    </div>
  );
};
